import { Chart } from "../Chart";
import { MouseEventParams } from "../lcharts/src/api/ichart-api";
import { Coordinate } from '../lcharts/src/model/coordinate';
import { AnnotationPriceLines } from "./AnnotationPriceLines";
import { UTCTimestamp } from '../lcharts/src/model/time-data';
import { DGDrawingServiceGlobal } from "src/app/Services/DrawingService";
import { IPriceLine } from "../lcharts/src/api/iprice-line";
import { AnnotationHorizontalLine } from './AnnotationHorizontalLine';
import { GLobalLastWaveTracker } from "./Tools/Global.LastWaveTracker";

export class Annotations {

  public annotationPriceLines: AnnotationPriceLines;
  public temporaryPriceLine: IPriceLine;
  public canvasItem: HTMLCanvasElement;
  public globalLastWaveTracker:GLobalLastWaveTracker;

  constructor(public chart: Chart) {
    this.annotationPriceLines = new AnnotationPriceLines(this.chart);

    this.canvasItem = DGDrawingServiceGlobal.drawingService().getCanvasElement("tist_0");

    this.traceMousePosition();
    this.traceClickAction();

    this.globalLastWaveTracker = new GLobalLastWaveTracker(this.chart);

  }

  public signals:number[] = [];
  public initPriceLines(data:string)
  {
    if(data=="")return;

    this.signals = [];

      let lines:any[] = JSON.parse(data);
      lines = lines.filter(v=>{
        return v.price!=0
      })

      lines.forEach(v=>{

        this.addNewPriceLine(null, true, v.price, v.color, v.isSignal);

        if(v.isSignal)
        {
          this.signals.push(v.price)
        }

      })

  }


  public update()
  {
    this.annotationPriceLines.update();
  }

  public addNewPriceLine(position, init?:boolean, price?:number, color?:string, isSignal?:boolean) {

    let valX =  DGDrawingServiceGlobal.drawingService().lastTIme;//this.chart.chart.timeScale().coordinateToTime(position.x) as UTCTimestamp;

      let priceValue;
      if(!init)
      {
          priceValue =  yToPrice(position.y,this.chart.chart);
      }
      else
      {
         priceValue =  price;
      }


    this.annotationPriceLines.addNewPriceLine(priceValue, valX as UTCTimestamp, true, init, color, isSignal);
    this.activatedPriceLineTracker = false;

  }

  public traceMousePosition() {
    this.canvasItem.addEventListener("mousemove", this.onMouseMove, false);
  }

  public traceClickAction() {
    this.canvasItem.addEventListener("mousedown", this.onMouseClick, false);
    this.canvasItem.addEventListener("touchstart", this.onMouseClick, false);

  }

  public onMouseMove(evt) {

    if (DGDrawingServiceGlobal.drawingService().annotations.activatedPriceLineTracker) {
      let position = DGDrawingServiceGlobal.drawingService().annotations.getMousePos(DGDrawingServiceGlobal.drawingService().annotations.canvasItem, evt);

      let priceValue = yToPrice(position.y as Coordinate, DGDrawingServiceGlobal.drawingService().annotations.chart.chart);

      let currentWidth = DGDrawingServiceGlobal.drawingService().getCanvasElement("tist_0").width;
      jQuery(`#t_temp`).css({ top: `${position.y}px`, width:`${currentWidth}px`, visibility:`visible`,height:`1px`, pointerEvents:`none` });
    }

  }

  public onMouseClick(evt) {


    let position = DGDrawingServiceGlobal.drawingService().annotations.getMousePos(DGDrawingServiceGlobal.drawingService().annotations.canvasItem, evt);

    //console.log(position);

    if (DGDrawingServiceGlobal.drawingService().annotations.activatedPriceLineTracker) {
      DGDrawingServiceGlobal.drawingService().annotations.addNewPriceLine(position);
    }
  }

  public getMousePos(canvas, evt) {
    var rect = canvas.getBoundingClientRect();

    if(evt.touches)
    {
       var touch = evt.touches[0];
      // alert(touch.pageX + " - " + touch.pageY);
      // alert((touch.pageX- rect.left) + " - " + (touch.pageY - rect.top));
      return {
        x:(touch.pageX- rect.left),
        y:(touch.pageY - rect.top)
      };
    }


    return {
      x: evt.clientX - rect.left,
      y: evt.clientY - rect.top
    };
  }


  private _activatedPriceLIneTracker: boolean = false;
  public get activatedPriceLineTracker(): boolean {
    return this._activatedPriceLIneTracker;
  }

  public set activatedPriceLineTracker(value: boolean) {

    if (value == true) {
     this.addTempPriceLIne();
     this._activatedPriceLIneTracker = value;
    }
    else {
      this.removeTempPriceLine()
      this._activatedPriceLIneTracker = value;
    }
  }

  public addTempPriceLIne() {
    // let valX = this.chart.chart.timeScale().coordinateToTime(0) as UTCTimestamp;
    // this.temporaryPriceLine = this.annotationPriceLines.addNewPriceLine(0, valX);
    this.chart.chart.applyOptions({
      crosshair: {
        horzLine: { visible: true },
        vertLine: { visible: false },
      }
    });
    let currentWidth = DGDrawingServiceGlobal.drawingService().getCanvasElement("tist_0").width;
    jQuery("#chartWrapper").append(`<div style="top: ${0}px; left: 10px; width:${currentWidth}px"; height:1px  class='priceLineHandler' id='t_temp'></div>`);

  }
  public removeTempPriceLine() {
    this.chart.chart.applyOptions({
      crosshair: {
        horzLine: { visible: true },
        vertLine: { visible: true }
      }
    })
    // this.annotationPriceLines.removePriceLIne(this.temporaryPriceLine);
    jQuery(`#t_temp`).remove();
    this.temporaryPriceLine = null;
  }

  public trackLastWave()
  {

  }




}


export function priceToY(price: number, chart) {
  let y = chart.getChartModel().mainPriceScale().priceToCoordinate(price, 0);
  return y
}

export function yToPrice(coordinate: Coordinate, chart) {
  let y = chart.getChartModel().mainPriceScale().coordinateToPrice(coordinate, 0);
  return y
}
